export const DELETE = 'DELETE';
export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
